(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.card-gallery').forEach((gallery) => {
      const scroller = gallery.querySelector('slideshow-slides');
      const dots = gallery.querySelectorAll('.card-gallery-dot');
      if (!scroller || dots.length === 0) return;

      scroller.addEventListener('scroll', () => {
        const slides = scroller.querySelectorAll('slideshow-slide');
        let activeIndex = 0;
        let minDist = Infinity;

        slides.forEach((slide, i) => {
          const dist = Math.abs(slide.getBoundingClientRect().left - scroller.getBoundingClientRect().left);
          if (dist < minDist) {
            minDist = dist;
            activeIndex = i;
          }
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle('card-gallery-dot--active', i === activeIndex);
        });
      }, { passive: true });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
